import { type CountryCode } from '@constants'
import { useCallbackEvent } from '@dni-react-hooks/use-callback-event'
import { useApiCampaignCheckoutDisplayFields } from '@hooks-api/fortune-fastpass/useApiCampaignCheckoutDisplayFields'
import { type Campaign } from '@hooks-api/types/dataModel/campaigns'
import * as billingService from '../core/billingService'
import { type BillingBaseStore } from '../types'
import { useFpCampaignCartStore } from './useFpCampaignCartStore'

export const useFpCampaignBillingService = (campaignCode: string, exhibitorSettings?: Campaign) => {
  const [cartValues, setCartValues] = useFpCampaignCartStore(exhibitorSettings?.campaign_id ?? null)

  const { destructuredData: checkoutFields, isLoading } = useApiCampaignCheckoutDisplayFields(
    exhibitorSettings
      ? { code: campaignCode, country_code: cartValues.billing.billingCountry ?? exhibitorSettings.region, language: exhibitorSettings.language }
      : undefined,
  )

  const setBilling = useCallbackEvent((billing: BillingBaseStore) => {
    setCartValues(state => ({
      ...state,
      billing,
    }))
  })

  const setBillingCountry = useCallbackEvent((billingCountry: CountryCode) => {
    setCartValues(state => ({
      ...state,
      billing: billingService.setBillingCountry(state.billing, billingCountry),
    }))
  })

  return {
    ...cartValues.billing,
    checkoutFields,
    isLoading,
    setBillingCountry,
    setBilling,
  }
}
